<template>
    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-card">
                    <div>
                        <div></div>
                        <div class="login-main">
                            <form class="theme-form" @submit.prevent="requestOTP">
                                <h4 class="text-center">Forgot Password?</h4>
                                <p class="text-center">Enter your email to receive a password reset OTP</p>
                                <div class="form-group">
                                    <label class="col-form-label">Email Address</label>
                                    <input v-model="email" class="form-control" type="email"
                                        placeholder="Enter your email" required>
                                </div>
                                <div class="form-group mb-0">
                                    <div class="text-end mt-3">
                                        <button class="btn btn-primary btn-block w-100" type="submit"
                                            :disabled="isSubmitting">
                                            {{ isSubmitting ? 'Sending...' : 'Send OTP' }}
                                        </button>
                                    </div>
                                </div>
                                <p class="mt-4 mb-0 text-center">
                                    <router-link class="ms-2" to="/auth/login">
                                        Back to Login
                                    </router-link>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { createToaster } from "@meforma/vue-toaster";
import { useRouter } from 'vue-router';
import axios from 'axios';

const baseUrl = process.env.VUE_APP_BASE_URL;
const toaster = createToaster({});
const router = useRouter();

const email = ref<string>("");
const isSubmitting = ref<boolean>(false);

async function requestOTP() {
    if (!email.value) {
        toaster.show("Please enter your email address", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
        return;
    }

    isSubmitting.value = true;
    try {
        const response = await axios.post(`${baseUrl}api/user/forgot-password-otp`, {
            email: email.value
        });

        toaster.show("If your email is registered, you will receive a password reset OTP.", {
            theme: 'outline',
            position: 'top-right',
            icon: 'check',
            type: 'success',
            duration: 3000
        });

        // Redirect to OTP verification page with email
        router.push({
            name: 'verifyOtp',
            query: { email: email.value }
        });
    } catch (error: any) {
        console.error('Error requesting OTP:', error);
        toaster.show(error.response?.data?.message || "Failed to send OTP. Please try again.", {
            theme: 'outline',
            position: 'top-right',
            icon: 'times',
            type: 'error',
            duration: 2000
        });
    } finally {
        isSubmitting.value = false;
    }
}
</script> 